import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Unit } from '../../models/unit';

@Component({
  selector: 'mj-mirror-parent-toggle',
  templateUrl: 'mirror-parent-toggle.component.html',
  styleUrls: ['mirror-parent-toggle.component.scss'],
})
export class MirrorParentToggleComponent {
  @Input() unit: Unit;
  @Input() field: string;
  @Output() update: EventEmitter<{
    field: string;
    value: boolean;
  }> = new EventEmitter<{ field: string; value: boolean }>();

  updateAction($event: any) {
    this.update.emit({ field: this.field, value: $event.checked });
  }

  get checkedStatus() {
    return this.unit[this.field];
  }
}
